import React from "react";
import Product from '../../../Products/Product';
import Grid from "@mui/material/Grid";
import { FavoriteProductWrapper } from './styles';

const FavoriteProduct = ({ ...props }) => {
  return (
    <FavoriteProductWrapper>
      <Grid container spacing={2} columns={{ xs: 12, sm: 12, md: 12 }}>
        {props.userFavorites.map(product => 
          <Grid
            item
            xs={6}
            sm={4}
            md={3}
            key={`${product.id}_${product.name}`}
          >
            <Product
              favorite
              item={product}
              getUserFavorites={props.getUserFavorites}
              key={product.id}/>
          </Grid>
        )}
      </Grid>
    </FavoriteProductWrapper>
  );
};

export default FavoriteProduct;
